import { t } from "@lingui/core/macro";
import {store} from "../App";

export function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export function isPinValid(pin) {
    return pin.every(digit => digit.match(/^[0-9]$/))
}

export function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}


export const handleStorageEvent = (e) => {
    // skip any storage events not triggered because of "authFlag" key
    if(e.key !== "authFlag") {
        return;
    }

    store.dispatch({type: "SET_IS_EXPIRED_TAB", isExpiredTab: true});
}

export function isEventSubType(subType) {
    // guests on an emailed hash link have no session, so no booking sub type
    return !!subType && subType.endsWith("Event");
}

export function joinWithCommasAndAnd(elements) {
    if (elements.length === 1) {
        return elements[0];
    }

    const firsts = elements.slice(0, elements.length - 1);
    const last = elements[elements.length - 1];

    return firsts.join(', ') +  " " + t({id: "and"}) + " " + last;
}

export function isInAllowedKeys(key){
    const allowedKeys = ["Tab", "Enter", "Escape"];
    if(allowedKeys.includes(key)) return true;
    return false;
};

// will only trim the string and add ... if string longer than limit +3 to avoid scenarios where we take 1 or 2 chars off the end and adding ... in its place
export function truncateStringLongerThan(string, limit) {
    if(!string) {
        return string;
    }

    if (string.length < limit + 3) {
        return string;
    }

    return string.substring(0, limit) + "...";
}

export function getDeckNumber(cabinInfo) {
    const deckNumber = cabinInfo.cabinDeck || getDeckNumberFromCabinNumber(cabinInfo.cabinNumber);
    return cabinInfo.cabinPosition ?
        `${deckNumber} ${cabinInfo.cabinPosition}` :
        deckNumber;

}

function getDeckNumberFromCabinNumber(cabinNumber) {
    if(cabinNumber.length === 5) {
        return cabinNumber.substring(0,2);
    }

    return cabinNumber.substring(0,1);
}